import { cloneDeep } from "lodash";
import {
    allBudgetTypesOptions,
    allClassificationTypesOptions,
    allDataSourcesOptions,
    allMeasureUnitsOptions,
    allMutuallyRedeemingLevelOptions,
    allStatusOptions,
    allPeriodicitiesOptions,
    allReportNamesOptions,
    allReportTypesOptions,
    allMutuallyRedeemingOptions,

} from "../../common/baseOptions";
import { Classificator } from "../../common/types/Classificator";
import { Template } from "../../common/types/Template";
import { ReportIPIPMFilterSettings } from "./settings/ReportIPIPMFilterSettings";
import { ReportIPIPMFilterOptions } from "./options/ReportIPIPMFilterOptions";
import { Indicator } from "../../common/types/Indicator";
import { Option } from "../../common/types/Option";
import { Segmentation, StatusType } from "../../common/types/roots/fields";
import { Draggable } from "@/modules/budget/monitoring/reports-constructor/common/types/Draggable";

export const reportMBSPExpenseClassificators: Classificator[] = [
    { key: 'gr', active: true, selected: [] },
    { key: 'abp', active: true, selected: [] },
    { key: 'prg', active: true, selected: [] },
    { key: 'ppr', active: true, selected: [] },
]
export const reportIPIPMIndicators: Indicator[] = [
    { key: 'expert_cost', active: true },
    { key: 'impl_period', active: true },
    { key: 'suplier_name', active: true },
    { key: 'suplier_bin', active: true },
    { key: 'contractnumbersys_1', active: true },
    { key: 'contractnumbersys_0', active: true },
    { key: 'contract_sum_0', active: true },
    { key: 'amount_this_year', active: true },
    { key: 'history', active: true },
    { key: 'history_rb', active: true },
    { key: 'history_nf', active: true },
    { key: 'history_ob', active: true },
    { key: 'history_mb', active: true },
    { key: 'history_vz', active: true },
    { key: 'history_br', active: true },
    { key: 'plan', active: true },
    { key: 'plan_rb', active: true },
    { key: 'plan_nf', active: true },
    { key: 'plan_ob', active: true },
    { key: 'plan_mb', active: true },
    { key: 'plan_vz', active: true },
    { key: 'plan_br', active: true },
    { key: 'fact', active: true },
    { key: 'fact_rb', active: true },
    { key: 'fact_nf', active: true },
    { key: 'fact_ob', active: true },
    { key: 'fact_mb', active: true },
    { key: 'fact_vz', active: true },
    { key: 'fact_br', active: true },
    { key: 'remain_plan', active: true },
    { key: 'remain_plan_rb', active: true },
    { key: 'remain_plan_nf', active: true },
    { key: 'remain_plan_ob', active: true },
    { key: 'remain_plan_mb', active: true },
    { key: 'remain_plan_vz', active: true },
    { key: 'remain_plan_br', active: true },
    { key: 'remain_dog_total', active: true },
    { key: 'remain_dog', active: true },
    { key: 'report_number', active: true },
    { key: 'montaj_act', active: true },
    { key: 'comment', active: true },
]

export const reportMBSPStatusOptions: Option<StatusType>[] = allStatusOptions
const segmentationOptions: Draggable<Segmentation>[] = [
    { value: 'REGION', label: "Регион", labelKk: "Аймақ", labelEn: "Region", active: false },
    { value: 'KBK', label: "КБК", labelKk: "БСК", labelEn: "KBK", active: false },
    { value: 'PROJECT', label: "Проект", labelKk: "Жоба", labelEn: "Project", active: true }
]

// Нужна как временная затычка (При созданий нового берутся пустые настройки)
const tempSettings: ReportIPIPMFilterSettings = {
    // Base:
    reportName: 'IPIPM',
    reportType: 'REGULATED',
    classificationType: 'EXPENSES',
    dataSource: 'LOADER',
    periodicity: 'PERIOD',
    // Custom:
    period: { from: '', to: '' },
    regions: [],
    measureUnit: 'THOUSAND',
    segmentations: cloneDeep(segmentationOptions),
    budgetTypes: [],
    mutuallyRedeeming: 'WITH',
    mutuallyRedeemingLevels: [],
    statuses: [],
    roundUpTo: null,
    isTree: true,
    expenses: [],
    indicators: cloneDeep(reportIPIPMIndicators)
}

export const reportIPIPMBaseTemplate: Template = {
    id: null,
    name: 'Исполнение плана по инвестиционным проектам в разрезе мероприятий',
    excelName: null,
    description: null,
    category: '80',
    regions: [],
    userId: '',
    filterSettings: tempSettings
}



export const reportIPIPMilterOptions: ReportIPIPMFilterOptions = {
    // Base:
    key: 'IPIPM',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions.filter(it => it.value === 'EXPENSES')),
    dataSources: cloneDeep(allDataSourcesOptions.filter(it => it.value === 'LOADER')),
    periodicities: cloneDeep(allPeriodicitiesOptions),
    // Custom:
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    regions: [], // Загружается с бэка
    segmentations: cloneDeep(segmentationOptions),
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    statuses: cloneDeep(reportMBSPStatusOptions),
    expenses: cloneDeep(reportMBSPExpenseClassificators),
    indicators: cloneDeep(reportIPIPMIndicators)
}
